import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appModalHost]',
})
export class MdnModalDirective {
  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }
}
